import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "./assets/home.svg";
import { ReactComponent as SearchIcon } from "./assets/search.svg";
import { ReactComponent as ProductsIcon } from "./assets/products.svg";
import { ReactComponent as ShopsIcon } from "./assets/shops.svg";
import { ReactComponent as MenuIcon } from "./assets/menu.svg";
import style from "./style.module.scss";

function TabBar({
  storeLocatorPage = "/",
  searchOpen,
  openSearchMenu,
  closeSearchMenu,
  burgerMenuOpen,
  openBurgerMenu,
  closeBurgerMenu,
}) {
  const { t } = useTranslation();

  const homeSelected =
    window.location.pathname === "/" && !searchOpen && !burgerMenuOpen;
  const productsSelected =
    window.location.pathname === "/product/" &&
    window.location.pathname !== "/" &&
    !searchOpen &&
    !burgerMenuOpen;
  const shopsSelected =
    window.location.pathname === storeLocatorPage &&
    window.location.pathname !== "/" &&
    !searchOpen &&
    !burgerMenuOpen;

  return (
    <div className={style.tabBar}>
      <div className={style.content}>
        <div
          className={clsx(style.tabIcon, homeSelected && style.selected)}
          onClick={() => {
            window.location.href = "/";
          }}
        >
          <HomeIcon />
          <span className={style.tabTitle}>{t("Home")}</span>
        </div>
        <div
          className={clsx(style.tabIcon, searchOpen && style.selected)}
          onClick={() => {
            if (!searchOpen) {
              openSearchMenu();
            } else {
              closeSearchMenu();
            }
          }}
        >
          <SearchIcon />
          <span className={style.tabTitle}>{t("Search")}</span>
        </div>
        <div
          className={clsx(style.tabIcon, productsSelected && style.selected)}
          onClick={() => {
            window.location.href = "/product/";
          }}
        >
          <ProductsIcon className={style.productsIcon} />
          <span className={clsx(style.tabTitle, style.productsTitle)}>
            {t("Products")}
          </span>
        </div>
        <div
          className={clsx(style.tabIcon, shopsSelected && style.selected)}
          onClick={() => {
            window.location.href = storeLocatorPage;
          }}
        >
          <ShopsIcon />
          <span className={style.tabTitle}>{t("Find a shop")}</span>
        </div>
        <div
          className={clsx(style.tabIcon, burgerMenuOpen && style.selected)}
          onClick={() => {
            if (!burgerMenuOpen) {
              openBurgerMenu();
            } else {
              closeBurgerMenu();
            }
          }}
        >
          <MenuIcon />
          <span className={style.tabTitle}>{t("Menu")}</span>
        </div>
      </div>
    </div>
  );
}

export default TabBar;
